import Service from "./Service";
import { useData } from "../../store/DataProvider";

const ServicesList = ({ isAdmin }) => {
    const {
        services,
        settings: { btnColors },
        selectedStaff,
    } = useData();

    /* One row that wraps. This used to be chunked into fixed groups of
       serviceColumns and padded with empty objects, which fought the CSS:
       .box-row is already `flex-flow: row wrap` and .card is
       `flex-basis: 150px; flex-grow: 1`, so the columns fall out of the
       available width on their own -- and adapt when that width changes. */
    return (
        <div className="box-row">
            {services.map((service, index) => (
                <Service
                    key={service._id}
                    service={service}
                    color={btnColors[index % btnColors.length]}
                    selectedStaff={selectedStaff}
                    isAdmin={isAdmin}
                />
            ))}
        </div>
    );
};

export default ServicesList;
